import(/* webpackMode: "eager" */ "/app/app/[locale]/(no-footer)/layout.tsx");
